import axios from "axios"

const TableService = {}

TableService.ajouter =(formData,authorization)=>{
return axios.post(`${process.env.REACT_APP_API_URL}/table/ajouter`, formData ,{
    headers: {
        'Authorization': `Bearer ${authorization}`
      }
})

}
export default TableService ;